import * as RadixDialog from '@radix-ui/react-dialog';
import React from 'react';

export interface IDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  /**
   * Allow Escape and outside clicks to close the dialog. Defaults to true.
   * Set to false for long forms, where a stray click would silently discard
   * everything the user typed — they close via an explicit cancel button instead.
   */
  isDismissable?: boolean;
}

export const Dialog: React.FC<IDialogProps> = (props) => {
  const { isOpen, onClose, title, children, isDismissable = true } = props;

  const preventDismiss = isDismissable ? undefined : (evt: { preventDefault: () => void }) => evt.preventDefault();

  return (
    <RadixDialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="dialog-overlay" />
        <RadixDialog.Content
          className="dialog-content"
          // We never render a Description; silences Radix's missing-description warning.
          aria-describedby={undefined}
          onEscapeKeyDown={preventDismiss}
          onPointerDownOutside={preventDismiss}
          onInteractOutside={preventDismiss}
        >
          <RadixDialog.Title className="heading-one mb-4">{title}</RadixDialog.Title>
          {children}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
};
